import Navbar from '../H&F/Navbar';
import Footer from '../H&F/Footer';
import Discliamber from './Discliamer'
import './terms-conditions.css';


import React, { useEffect } from 'react';
export default function TERMSCONDITIONS() {


  
    useEffect(() => {
                window.scrollTo(0, 0); // Scroll to the top of the page
              }, []);
  return (
    <>
    
    <div><Navbar/></div>
















    <section id="terms-and-conditions">
    <div class="container">
      <h2>Terms and Conditions</h2>
      <p>Welcome to <strong>Home Appliance Service Madurai</strong>. By using our services, you agree to the following terms and conditions outlined below:</p>

      <h3>Services Provided</h3>
      <p>We offer repair and maintenance services for a variety of home appliances, including but not limited to washing machines, fridges, microwaves, water purifiers, and more. The services are performed by our trained professionals to ensure quality and customer satisfaction.</p>

      <h3>Service Appointments</h3>
      <p>All appointments for services should be scheduled in advance. We will confirm the date and time of your service appointment. Please ensure you are available during the scheduled time. If you need to reschedule, kindly inform us at least 24 hours prior to the appointment.</p>

      <h3>Pricing and Payment</h3>
      <p>Prices for services will be quoted upfront. The total cost of the service will depend on the type and extent of the repair required. Payment is due at the time of service completion. We accept cash and online payment methods.</p>

      <h3>Customer Responsibilities</h3>
      <p>As a customer, you agree to provide accurate and complete information regarding the appliances that need service. You are responsible for ensuring access to the appliances at the scheduled time of the service. If there are any issues accessing the appliance, the service may be delayed or canceled.</p>

      <h3>Limitation of Liability</h3>
      <p>While we strive to provide the best possible service, <strong>Home Appliance Service Madurai</strong> is not liable for any damage caused to the appliance during the repair process, except in cases of gross negligence by our technicians. We are also not responsible for any damages resulting from a prior faulty installation or use of the appliance.</p>

      <h3>Data Privacy</h3>
      <p>We respect your privacy. Your personal information will only be used to provide the services requested. We will not share your personal data with third parties unless required by law.</p>

      <h3>Changes to Terms and Conditions</h3>
      <p>We reserve the right to update or modify these terms and conditions at any time. Any changes will be communicated through our website, and your continued use of our services constitutes acceptance of those changes.</p>

      <h3>Contact Us</h3>
      <p>If you have any questions or concerns regarding our terms and conditions, please contact us at <strong><a href="mailto:hasmadurai@gmail.com">hasmadurai@gmail.com</a></strong> or call <strong>+918610867933</strong>.</p>
    </div>
</section>









<div><Discliamber/></div>

<div><Footer/></div>
    
    
    </>
  )
}
